module.exports = __webpack_public_path__ + "img/sig-bsc.570b4ace.png";